import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/luck77/luck_star.png'
import _imports_1 from '../../assets/luck77/res-icon.png'
import _imports_2 from '../../assets/luck77/888-icon.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-549a7152"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "download-footer" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img class=\"left\" src=\"" + _imports_0 + "\" alt=\"\" data-v-549a7152><div class=\"mid\" data-v-549a7152><p class=\"text\" data-v-549a7152>Download APP</p><p class=\"res\" data-v-549a7152><img src=\"" + _imports_1 + "\" alt=\"\" data-v-549a7152><img src=\"" + _imports_2 + "\" alt=\"\" data-v-549a7152></p><p class=\"conment\" data-v-549a7152><i class=\"five-star\" data-v-549a7152></i>8000+</p></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "right",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadApp && _ctx.downloadApp(...args)))
    })
  ]))
}